var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "div",
        { staticClass: "m-fast-payment-system" },
        [
          _c("f-sprite-icon", {
            staticClass: "m-fast-payment-system__spb-icon",
            attrs: { "icon-link": _vm.$options.icons.IconSpb.id }
          }),
          _c(
            "div",
            { staticClass: "m-fast-payment-system__header" },
            [
              _c("div", { staticClass: "m-fast-payment-system__title" }, [
                _vm._v("\n      Выберите банк для подтверждения оплаты\n    ")
              ]),
              _c("ui-input", {
                staticClass: "m-fast-payment-system__search",
                attrs: {
                  disabled: _vm.loading,
                  clearable: "",
                  placeholder: "Найти банк"
                },
                model: {
                  value: _vm.query,
                  callback: function($$v) {
                    _vm.query = $$v
                  },
                  expression: "query"
                }
              })
            ],
            1
          ),
          _vm.loading
            ? _c("ui-loader", {
                staticClass: "m-fast-payment-system__loader",
                attrs: { size: "64" }
              })
            : [
                _vm.recommendedBanks.length && _vm.query.length < 2
                  ? _c(
                      "div",
                      { staticClass: "m-fast-payment-system__recommendation" },
                      [
                        _c(
                          "div",
                          { staticClass: "m-fast-payment-system__label" },
                          [
                            _vm._v(
                              "\n        Вы выбирали в прошлый раз\n      "
                            )
                          ]
                        ),
                        _vm._l(_vm.recommendedBanks, function(bank) {
                          return _c("m-fast-payment-system-bank", {
                            key: bank.bankName,
                            attrs: { bank: bank, "qr-url": _vm.data.qrUrl }
                          })
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.filteredBanks.length
                  ? _c(
                      "div",
                      { staticClass: "m-fast-payment-system__list" },
                      [
                        _vm.recommendedBanks.length
                          ? _c(
                              "div",
                              { staticClass: "m-fast-payment-system__label" },
                              [_vm._v("\n        Все банки\n      ")]
                            )
                          : _vm._e(),
                        _vm._l(_vm.filteredBanks, function(bank) {
                          return _c("m-fast-payment-system-bank", {
                            key: bank.bankName,
                            attrs: { bank: bank, "qr-url": _vm.data.qrUrl },
                            nativeOn: {
                              click: function($event) {
                                return _vm.onSelectBank(bank.bankName)
                              }
                            }
                          })
                        })
                      ],
                      2
                    )
                  : _c("div", { staticClass: "m-fast-payment-system__label" }, [
                      _vm._v(
                        "\n      По Вашему запросу результатов не найдено\n    "
                      )
                    ])
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }